import produce from 'immer';
import {
  INVITATION_EVENT_ADD_BUDGET,
  INVITATION_EVENT_CREATE_REQUEST, INVITATION_EVENT_DEPOSIT_REQUEST, INVITATION_EVENT_INFO_DELETE_REQUEST,
  INVITATION_EVENT_INFO_DETAILS,
  INVITATION_EVENT_INFO_DETAILS_REQUEST,
  INVITATION_EVENT_INFO_UPDATE_REQUEST,
  INVITATION_EVENT_LIST,
  INVITATION_EVENT_LIST_REQUEST, INVITATION_EVENT_PAGE_RESET,
  INVITATION_EVENT_RESPONSE_MESSAGE, SET_INVITATION_EVENT_PAGINATION, SET_TOTAL_COUNT
} from '../../constants/event/invitationEventConstants';

const initialState = {
  list: [],
  resultCode: null,
  message: null,
  page: 1,
  pageLength: 10,
  totalCount: 0,
  searchString: '',
  searchType: '',
  scheduleInfo: [],
  logInfo: [],
};

const invitationReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case INVITATION_EVENT_LIST_REQUEST:
      break;
    case INVITATION_EVENT_LIST:
      draft.list = action.list;
      break;
    case INVITATION_EVENT_RESPONSE_MESSAGE:
      draft.resultCode = action.resultCode;
      draft.message = action.message;
      break;
    case INVITATION_EVENT_CREATE_REQUEST:
      break;
    case INVITATION_EVENT_INFO_DETAILS_REQUEST:
      break;
    case INVITATION_EVENT_INFO_DETAILS:
      draft.scheduleInfo = action.scheduleInfo;
      draft.logInfo = action.logInfo;
      break;
    case INVITATION_EVENT_INFO_UPDATE_REQUEST:
      break;
    case INVITATION_EVENT_INFO_DELETE_REQUEST:
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_INVITATION_EVENT_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.searchType = action.searchType;
      draft.searchString = action.searchString;
      break;
    case INVITATION_EVENT_PAGE_RESET:
      draft.page = 1;
      break;
    case INVITATION_EVENT_DEPOSIT_REQUEST:
      break;
    case INVITATION_EVENT_ADD_BUDGET:
      break;
    default:
      break;
  }
});

export default invitationReducer;
